/**
 * Registra actividad de usuarios en activity_logs.
 * No registra acciones de usuarios con rol Administrador (solo actividad del equipo).
 */
import { supabase } from '../lib/supabase';

export type ActionType = 'create' | 'update' | 'delete' | 'view';

export interface LogActivityParams {
  action: string;
  entity_type: string;
  entity_id?: string | null;
  details: string;
  action_type: ActionType;
}

export async function logActivity(params: LogActivityParams): Promise<void> {
  try {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user?.id) return;

    const role = String(user.app_metadata?.app_role || user.user_metadata?.app_role || '').trim();
    if (role === 'Administrador' || role === 'Super Admin') return;

    await supabase.from('activity_logs').insert({
      user_id: user.id,
      action: params.action,
      entity_type: params.entity_type,
      entity_id: params.entity_id ?? null,
      details: params.details,
      action_type: params.action_type,
    });
  } catch {
    // Fire-and-forget: no romper el flujo principal si falla el log
  }
}
